import {Component, Injector, PLATFORM_ID} from '@angular/core';
import {RouteUtil} from '../util/route.util';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {isPlatformBrowser, Location} from '@angular/common';
import {StringUtil} from '../util/string.util';
import {NetworkUtil} from '../util/network.util';
import {ServiceApi} from '../network/service.api';
import {strings} from '../values/strings';
import moment from 'jalali-moment';
import {SeoService} from "../util/service/seo.service";

@Component({
  template: ''
})
export abstract class BaseComponent {

  strings = strings;
  message = '';
  Route = RouteUtil;
  public serviceApi: ServiceApi;
  public router: Router;
  public matDialog: MatDialog;
  public matSnackBar: MatSnackBar;
  public activatedRoute: ActivatedRoute;
  public location: Location;
  protected value?: string;
  protected page = 1;
  protected size = 20;
  protected total = 1;
  protected isBrowser: boolean;
  public seoService: SeoService

  protected constructor(injector: Injector) {
    const platformId = injector.get(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(platformId);
    this.isBrowser = isPlatformBrowser(platformId);
    this.serviceApi = injector.get(ServiceApi);
    this.router = injector.get(Router);
    this.matDialog = injector.get(MatDialog);
    this.matSnackBar = injector.get(MatSnackBar);
    this.activatedRoute = injector.get(ActivatedRoute);
    this.location = injector.get(Location);
    this.seoService = injector.get(SeoService);
  }

  ngOnInit(): void {
    this.executeLoader();
  }

  ngAfterViewInit(): void {
  }

  ngAfterContentInit(): void {
  }

  public executeLoader(): void {
    if (!this.isBrowser) return;
    if (NetworkUtil.isInternetConnected()) {
      this.loadOnline();
    } else {
      this.loadOffline();
    }
  }

  public onInternetConnected(): void {

    this.executeLoader();
  }

  public loadOnline(): void {
    if (!this.isBrowser) return;
  }

  public loadOffline(): void {
  }

  onBackPressed() {
    this.location.back();
  }

  onForwardPressed() {
    this.location.forward();
  }

  removeDashes(value: string): string {
    return value.replace(/-/g, '');
  }

  castToGeorgian(date: string): string | null {
    if (date && date !== '') {
      return moment(date, 'YYYY/MM/DDTHH:mm:ss.000Z').locale('en').format('YYYY-MM-DDTHH:mm:ss.000Z');
    }
    return null;
  }

  integerAsCurrency(integer: number | undefined): string {
    return StringUtil.integerAsCurrency(<number>integer);
  }

  formatAmount(integer: number | undefined): string {
    return StringUtil.formatAmount(<number>integer);
  }

  convertNumberToPersianWords(integer: number | undefined): string {
    return StringUtil.convertNumberToPersianWords(<number>integer);
  }

  removeCommasAndConvertToNumber(value: string | undefined): number {
    return StringUtil.removeCommasAndConvertToNumber(<string>value);
  }

  isPasswordHashNumberAndLetters(pass?: string): boolean {
    return !(pass == null || pass.trim().length < 6 || !pass.match(".*[0-9]+.*") || !pass.match(".*[a-zA-Z]+.*"));
  }

  convertTimestampToPersianDateTime(timestamp: number): string {
    const jalaliDate = moment(timestamp * 1000).format('jYYYY/jM/jD HH:mm');
    return jalaliDate;
  }

  convertTimestampToPersian(timestamp: any) {
    const timestampInSeconds = Math.floor(timestamp / 1000);
    const jalaliDate = moment.unix(timestampInSeconds).format('jYYYY/jM/jD');
    return jalaliDate;
  }

  convertTimestampTicketToPersian(timestamp: number): string {
    const jalaliDate = moment(timestamp).format('jYYYY/jM/jD');
    return jalaliDate;
  }

  // formatImage(file: any | null, defaultImageUrl: string): Promise<string | null> {
  //   return ImageUtil.formatImage(file, defaultImageUrl);
  // }

}
